import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './useAuth';
import { getAnalyticsConsent, isAnalyticsCollectionAllowed, logAnalyticsError, setTrafficOrigin, trackPageView } from '../lib/analytics';

export const usePageAnalytics = () => {
  const location = useLocation();
  const { currentUser, loading } = useAuth();
  const [consent, setConsent] = useState(getAnalyticsConsent);
  const previousUrl = useRef<string | undefined>(undefined);
  const lastPath = useRef<string | undefined>(undefined);

  useEffect(() => {
    const handleConsent = () => setConsent(getAnalyticsConsent());
    window.addEventListener('doganju:analytics-consent', handleConsent);
    return () => window.removeEventListener('doganju:analytics-consent', handleConsent);
  }, []);

  useEffect(() => {
    setTrafficOrigin(currentUser?.uid);
  }, [currentUser?.uid]);

  useEffect(() => {
    if (consent !== 'accepted') {
      lastPath.current = undefined;
      return;
    }
    if (!isAnalyticsCollectionAllowed()) return;
    if (loading || lastPath.current === location.pathname) return;
    const referrer = previousUrl.current;
    lastPath.current = location.pathname;
    previousUrl.current = `${window.location.origin}${location.pathname}`;
    void trackPageView(location.pathname, document.title, referrer).catch(logAnalyticsError);
  }, [location.pathname, loading, consent]);
};
